module.exports = __webpack_public_path__ + "static/media/board-Steven_Gooden.d1988ec2.jpg";